import type { SupportedRegion } from "../utils/regionRedirect";
// import FeaturedPackages from '../components/LandingComp/FeaturedPackages'
import HeroSection from '../components/LandingComp/HeroSection'
import PopularSection from '../components/LandingComp/PopularSection'
import VisaServices from '../components/LandingComp/VisaServices'
import WhyChoose from '../components/LandingComp/WhyChoose'
import FollowUs from "../components/LandingComp/FollowUs";
import April from "../components/LandingComp/April";
import EarlyBirds from "../components/LandingComp/EarlyBirds";

type LandingPageProps = {
  detectedRegion?: SupportedRegion | null;
  showRegionPopup?: boolean;
  onCloseRegionPopup?: () => void;
  onGoToIndiaSite?: () => void;
  onGoToUaeSite?: () => void;
   showAprilSection?: boolean
  showEarlyBirdsSection?: boolean
}

function LandingPage({
  detectedRegion = null,
  showRegionPopup = false,
  onCloseRegionPopup,
  onGoToIndiaSite,
  onGoToUaeSite,
   showAprilSection = true,
  showEarlyBirdsSection = true
}: LandingPageProps) {
  return (
    <div>
      <HeroSection
        detectedRegion={detectedRegion}
        showRegionPopup={showRegionPopup}
        onCloseRegionPopup={onCloseRegionPopup}
        onGoToIndiaSite={onGoToIndiaSite}
        onGoToUaeSite={onGoToUaeSite}
      />
      {showAprilSection && <April />}
            {showEarlyBirdsSection && <EarlyBirds />}

      <PopularSection />
      {/* <FeaturedPackages /> */}
      <VisaServices />
            <FollowUs />
      <WhyChoose />
    </div>
  )
}

export default LandingPage
